import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { PatientMedicine, PatientMedicineQuery } from '@dreryk/egabinet-prescription-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { Ordering } from '@dreryk/react-common';
import { TextPattern } from '@dreryk/watermelon';

import { MedicineSearchText, MedicineSelectorIcd10Code } from '../../medicineSelector.types';
import { COMMERCIAL_MEDICINE_NAME_COLUMN } from '../MedicineSelectorTable.hooks';

// TODO: DREGAB-1669 set valid type when mechanism to sort on custom fields will be available
const DEFAULT_ORDERINGS: Ordering<any>[] = [
   {
      property: COMMERCIAL_MEDICINE_NAME_COLUMN,
      descending: false,
   },
];
export const useSearchResultsMedicineSelectorConfiguration = (
   patientId: Patient['id'],
   selectedIcd10Codes: MedicineSelectorIcd10Code[],
   medicineSearchText: MedicineSearchText
): LazyLoadedDataConfigurationByCqrsQuery<PatientMedicine> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<PatientMedicine>(() => {
      const patientMedicineQuery = new PatientMedicineQuery();
      patientMedicineQuery.searchText = TextPattern.anywhereIgnoreCase(medicineSearchText ?? undefined);
      patientMedicineQuery.patientId = patientId;

      if (selectedIcd10Codes.length) {
         patientMedicineQuery.icd10Codes = selectedIcd10Codes.map((code) => code.icd10Code);
      }

      return patientMedicineQuery;
   }, DEFAULT_ORDERINGS);
};
